import React from 'react'

const DocumentTitle = ({ title, type, transaction }) => {
  const isVisible = (type === 'carrier' && transaction?.truckVisible) || (type === 'shipper' && transaction?.loadVisible)

  return isVisible
    ? (
      <div className="d-flex justify-space align-center border-b pb-8 mb-8">
        <h3 className="mb-0">
          {title}
        </h3>
      </div>
    ) : null
}
export default DocumentTitle
